export const workflowOperators = Object.freeze({
    algebraic: {
        label: 'Algebraic',
        list: ['+', '-', '*', '/', '%']
    },
    equality: {
        label: 'Equality',
        list: ['==', '=', '!=', '!==']
    },
    relational: {
        label: 'Relational',
        list: ['<', '<=', '>', '>=']
    },
    logical: {
        label: 'Logical',
        list: ['&&', '||', '!']
    },
    conditional: {
        label: 'Conditional',
        list: ['if', 'ifempty']
    }
})
